import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfilePreferencesService } from '@scap/profile/data-access/profile-preferences.service';

export const initRouteGuard: CanActivateFn = async () => {

  const router = inject(Router)
  const preferences = inject(ProfilePreferencesService)

  const ruta = await preferences.initRoute()
  return router.parseUrl(ruta)
}
